module.exports = __webpack_public_path__ + "img/20190821145056QQ截图20190821130743.75e55975.png";